import { has, omit, set } from "lodash";

function setDeepErrors(payload, errors) {
  Object.keys(payload).forEach(field => {
    if (payload[field].errors) {
      set(errors, field, payload[field]);
    }
  });
}

function setErrors({ commit }, payload) {
  const error = {};

  Object.keys(payload).forEach(field => set(error, field, payload[field]));

  if (payload.errors) {
    setDeepErrors(payload.errors.children, error);
    commit("SET_COMMON_ERRORS", payload.errors.errors);
  }

  commit("SET_ERRORS", error);
}

function deleteErrors({ commit, state }, path) {
  if (has(state.errors, path)) {
    const error = omit(state.errors, path);

    commit("SET_ERRORS", error);
  }
}

function deleteCommonErrors({ commit, state }, path) {
  if (has(state.commonErrors, path)) {
    const error = omit(state.commonErrors, path);

    commit("SET_COMMON_ERRORS", error);
  }
}

function clearErrors({ commit }) {
  commit("CLEAR_ERRORS");
}

function clearCommonErrors({ commit }) {
  commit("CLEAR_COMMON_ERRORS");
}

export default {
  setErrors,
  clearErrors,
  deleteErrors,
  deleteCommonErrors,
  clearCommonErrors
};
